import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { CLASSNAME } from "utils/constant";
import { formatNorwegianNumber } from "utils/helper";

const GroupFooterCell = (props: GridCustomCellProps) => {
	let content = "";

	if (props.dataItem.field === "group1") {
		const formatDecimal = 2;
		if (props.field === "netLiveWeightKg") {
			return (
				<td
					{...props.tdProps}
					className={`${props.className}  ${CLASSNAME.TableNumeric} no-border td-bold`}
				>
					<div style={{ marginTop: "-20px" }}>
						{`${formatNorwegianNumber(
							props.dataItem.aggregates.netLiveWeightKg.sum,
							formatDecimal,
							formatDecimal
						)} kg`}{" "}
					</div>
				</td>
			);
		} else if (props.field === "productText") {
			return (
				<td {...props.tdProps} className="td-bold" style={{}}>
					<div style={{ height: "60px" }}>
						<span style={{ marginTop: "20px", display: "block" }}>
							{" "}
							Sum {props.dataItem.items[0].group1}{" "}
						</span>
					</div>
				</td>
			);
		}
	}

	return (
		<td {...props.tdProps} colSpan={1}>
			{content}
		</td>
	);
};

export default GroupFooterCell;
